export default __webpack_public_path__ + "static/media/question_20.a3158949.png";